export default __webpack_public_path__ + "static/media/Play Dots@2x.3bccb972.png";